import { CallSolicitationOutcomeMap } from '../models/call-solicitations.models';

export type CallSolicitationRejectionType = 'admin' | 'expert';

export type CallSolicitationRejectionOutcome =
  | CallSolicitationOutcomeMap.AdminRejection
  | CallSolicitationOutcomeMap.ExpertRejection;

export const CALL_SOLICITATION_REJECTION_OUTCOMES: readonly CallSolicitationOutcomeMap[] =
  [
    CallSolicitationOutcomeMap.AdminRejection,
    CallSolicitationOutcomeMap.ExpertRejection,
  ];

export function isCallSolicitationRejectionOutcome(
  outcome: CallSolicitationOutcomeMap | null | undefined
): outcome is CallSolicitationRejectionOutcome {
  return (
    outcome === CallSolicitationOutcomeMap.AdminRejection ||
    outcome === CallSolicitationOutcomeMap.ExpertRejection
  );
}

export function getCallSolicitationRejectionType(
  outcome: CallSolicitationOutcomeMap | null | undefined
): CallSolicitationRejectionType | null {
  switch (outcome) {
    case CallSolicitationOutcomeMap.AdminRejection:
      return 'admin';
    case CallSolicitationOutcomeMap.ExpertRejection:
      return 'expert';
    default:
      return null;
  }
}
